import { useMutation, useQueryClient } from '@tanstack/react-query';
import { post } from '@truefit/http-utils';

import { cronJobsQueryKey } from './useCronJobsQuery';

export interface RestartCronResponse {
  queued: boolean;
  id: string;
}

/**
 * Queues a reinstall of one cron on the scheduler.
 *
 * A success here means the job was accepted, not that the cron is back — the
 * scheduler does the work. The list query is invalidated so the row's real
 * status comes from the next poll rather than an optimistic guess.
 */
export const useRestartCronMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string): Promise<RestartCronResponse> => {
      // http-utils types `data` as required, so the empty body is explicit —
      // the id is carried in the path.
      const { data } = await post<RestartCronResponse>(
        `/v1.0/internals/crons/${encodeURIComponent(id)}/restart`,
        {},
      );
      return data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: cronJobsQueryKey }),
  });
};

export default useRestartCronMutation;
